webpackJsonp([181847311802219],{

/***/ 561:
/***/ (function(module, exports) {

	module.exports = {"data":{"markdownRemark":{"frontmatter":{"date":"2022-05-24","path":"/projects/brillpill","summary":"CMS-driven website for online pharmacy","tags":["web","fedev","bedev","craft","twig","php","typescript","css","kor"],"taskSummary":"one of two main developers","title":"Brillpill","url":null,"writeupDate":"2023-01-20"},"html":"<p>At the time of writing this is still just a “coming soon” page,\neven about a year after I finished my work on it.</p>\n<p>It’s a website driven by Craft CMS, using the content builder pattern.</p>\n<p>A large number of content blocks have been prepared and tested,\nthough not many of those are currently visible publicly.</p>\n<h2>Update in 2026</h2>\n<p>It looks like this company never got off the ground –\nwhen I go to the URL it was being served at, brillpill.com,\nI now see just Nginx’s hello message.</p>\n<p>Too bad.</p>"}},"pathContext":{}}

/***/ })

});


// WEBPACK FOOTER //
// path---projects-brillpill-6168afeb9edb135a6b5e.js